import * as swcHelpers from '@swc/helpers';

function getForwardedQueryParamsFromFacets(facets, currentRefinements) {
    const params = facets.reduce((result, facet)=>{
        if (!currentRefinements || Object.keys(currentRefinements).length === 0) {
            return result;
        }
        const currentRefinement = currentRefinements[facet.attribute];
        if (facet.forwardAsQueryParam && facet.attribute in currentRefinements && currentRefinement) {
            return swcHelpers.objectSpread({}, result, {
                [facet.id]: currentRefinement.join(',')
            });
        }
        return result;
    }, {});
    if (Object.keys(params).length === 0) {
        return undefined;
    }
    return params;
}

export { getForwardedQueryParamsFromFacets };
//# sourceMappingURL=get-forwarded-query-params-from-facets.js.map
